(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds.js');

(function(Backbone, _, svs) {
  svs.matchen.views.MatchenOdds = Marionette.View.extend({
    template: function(data) {
      return svs.matchen.templates.matchen_odds(data);
    },

    className: 'matchen-odds',

    initialize: function() {
      if (!svs.core.detect.formfactor.mobile()) {
        this.setElement('.matchen-slider-folder');
      }
    },

    ui: {
      closeBtn: '.js-close-odds-folder'
    },

    events: {
      'click @ui.closeBtn': 'hideOddsFolder'
    },

    modelEvents: {
      resetOutcomes: 'render'
    },

    regions: {
      oddsSwitch: '.js-odds-switch-container',
      oddsHeadings: '.js-odds-headings-container',
      myOddsList: '.matchen-my-odds-list',
      oddsList: '.matchen-odds-list'
    },

    myOddsIsCurrentView: true,

    onRender: function() {
      var switchView = new svs.matchen.views.MatchenOddsSwitch();
      var headingsView = new svs.matchen.views.MatchenOddsHeadings({
        model: this.model.get('draw')
      });
      var myOddsCollection = new svs.matchen.collections.MyOdds(null, {
        drawNumber: this.model.get('draw').get('drawNumber'),
        modelData: this.model
      });
      this.dimmer = this.dimmer || $('.matchen-odds-dimmer');
      this.dimmer.on('click', this.hideOddsFolder.bind(this));
      this.showChildView('oddsSwitch', switchView);
      this.showChildView('oddsHeadings', headingsView);
      this.showChildView(
        'myOddsList',
        new svs.matchen.views.MatchenOddsMine({
          model: this.model,
          collection: myOddsCollection
        })
      );

      if (this.model.get('isValid')) {
        myOddsCollection.fetch({
          reset: true
        });
      }

      this.listenTo(switchView, 'changeOddsView', this.changeOddsView);
      this.listenTo(headingsView, 'sortOddsList', this.sortOddsCollection);
    },

    changeOddsView: function(data) {
      if (!this.getRegion('oddsList').hasView()) {
        this.allOddsCollection = new svs.matchen.collections.AllOdds(null, {
          drawNumber: this.model.get('draw').get('drawNumber')
        });

        this.showChildView(
          'oddsList',
          new svs.matchen.views.MatchenOddsAll({
            collection: this.allOddsCollection,
            childView: svs.matchen.views.MatchenOddsItem
          })
        );

        if (svs.core.detect.formfactor.mobile()) {
          this.listenToOnce(this.allOddsCollection, 'sync', function() {
            $(window.document).trigger('resizeTabView');
          });
        }
      }

      if (data === 'my-odds') {
        this.getRegion('myOddsList').$el.removeClass('hide');
        this.getRegion('oddsList').$el.addClass('hide');
      } else if (data === 'least-most') {
        this.getRegion('oddsList').$el.removeClass('hide');
        this.getRegion('myOddsList').$el.addClass('hide');
      }

      if (svs.core.detect.formfactor.mobile()) {
        $(window.document).trigger('resizeTabView');
      }
    },

    sortOddsCollection: function(changeOrder) {
      if (this.getRegion('oddsList').hasView()) {
        changeOrder = typeof changeOrder === 'undefined' ? true : changeOrder;
        if (changeOrder) {
          this.getRegion('oddsList').currentView.collection.sortByAsc =
          !this.getRegion('oddsList').currentView.collection.sortByAsc;
        }
        if (this.getRegion('oddsList').currentView) {
          this.allOddsCollection.sortAllLists();
        }
      }

      if (this.getRegion('myOddsList').currentView) {
        changeOrder = typeof changeOrder === 'undefined' ? true : changeOrder;
        if (changeOrder) {
          this.getRegion('myOddsList').currentView.collection.sortByAsc =
          !this.getRegion('myOddsList').currentView.collection.sortByAsc;
        }
        this.getRegion('myOddsList').currentView.collection.sortByColumn([
          {
            key: 'odds',
            order: this.getRegion('myOddsList').currentView.collection.sortByAsc ?
              'asc' :
              'desc',
            keyParse: function(val) {
              return parseFloat(val.replace(',', '.'));
            }
          },
          {
            key: 'sortingKey',
            order: 'asc'
          }
        ]);
      }
    },

    hideOddsFolder: function() {
      svs.components.Storage.browser.get('oddsOpen', 'matchen', function(data) {
        if (typeof data === 'undefined') {
          svs.components.Storage.browser.set('oddsOpen', 'matchen', true);
        } else {
          svs.components.Storage.browser.remove('oddsOpen', 'matchen');
        }
      });

      this.dimmer.removeClass('matchen-odds-dimmer-visible');
      $('.matchen-odds-context-toggle')
        .find('input')
        .prop('checked', false);
      this.$el.removeClass('matchen-slider-folder-open');
    }
  });
})(Backbone, _, svs);


 })(window);